import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
export interface IChat {
	sender: Member;
	room: Room | null | undefined;
	time: string;
	message: String,
	id: String
}

export interface Room {
	name: String,
	id: String,
	createdBy: string,
}

export interface Member {
	username: string;
	fullname: string;
	id: String;
	email: String;
}


export interface UserState {
	value: number,
	active: Room | null,
	profile: Member,
	leftIsOpen: boolean,
	chats: Array<IChat>
}

const initialState: UserState = {
	value: 0,
	active: null,
	chats: [],
	leftIsOpen: true,
	profile: {
		id: "",
		email: "",
		username: "",
		fullname: "",
	}
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setProfile: (state, action: PayloadAction<object>) => {
			state.profile = { ...state.profile, ...action.payload }
		},
		setActive: (state, action: PayloadAction<Room>) => {
			state.leftIsOpen = false;
			if (state.active?.id === action.payload.id) return;
			state.active = action.payload
		},
		setLeftIsOpen: (state, action: PayloadAction<boolean>) => {
			state.leftIsOpen = action.payload
		},
		setChat: (state, action: PayloadAction<IChat>) => {
			let exist = state.chats.find((each, i) => each.id === action.payload.id);
			if (exist) return;
			state.chats = [...state.chats, action.payload];
		}
	},
})

// Action creators are generated for each case reducer function
export const { setProfile, setActive, setLeftIsOpen, setChat } = userSlice.actions

export default userSlice.reducer